export default __webpack_public_path__ + "static/media/talk-to-friends.945872a1.png";